import React from 'react';
import TutorialVideo from '../components/TutorialVideo';
// import TutorialQuestion from '../components/TutorialQuestion';
import {inject} from 'mobx-react';
import HttpClient from 'services/HttpClient';
import {withRouter, Link} from 'react-router-dom';
import {VIMEO_PLAYER_PREFIX} from 'constants/baseConst';
// import QuestionsQuiz from 'modules/blocks/tutorial_popup/QuestionsQuiz';
// import classNames from 'classnames';
import QuizModal from '../components/QuizModal';

const TUTORIAL_DETAILS = '/api/v1/tutorials/';
const ANSWERS = '/api/v1/results/';
// const CERTIFICATE = '/api/v1/pdfs/'

// POST api/v1/results/id = id туторіала
// ansvers:[{id id, correct: true}]

@withRouter
@inject('userStore')
@inject('alertStore')
@inject('preloaderStore')
export default class Tutorial extends React.Component {

  state = {
    tutorial: {
      questions: []
    },
    isOpenQuizModal: false,
    answers: [{}],
    quizNumber: 0,
    quizResult: null
  };

  componentWillMount(){
    this.props.preloaderStore.activate();
    this.initTutorial();
  }

  componentDidMount() {
    if(this.props.location.openQuiz)
      setTimeout(this.openQuizModal, 300);
  }

  componentWillUnmount(){
    this.props.preloaderStore.disable();
  }

  initTutorial = () => {
    new HttpClient().get(TUTORIAL_DETAILS + this.props.match.params.slug).then(response => {
      this.setState({tutorial: response.body.data.tutorial})
    }).catch( (e) => {
      if(e.status === 403) {
        // this.props.alertStore.success('Subscribe please');
        this.props.history.push('/settings/payments');
      }
    })
  };

  // getCertificate = () => {
  //   const { tutorial } = this.state;
  //
  //   new HttpClient().get(CERTIFICATE + tutorial.id)
  //   .then(response => {
  //     var myWindow = window.open('', '_blank');
  //     myWindow.document.write(response)
  //     // console.log(response);
  //   });
  // }

  isOverOneRow = () => {
    let q_preview = this.state.tutorial.questions;
    if(q_preview.length > 3){
      return true;
    } else return false;
  };

  onAnswerEdit = (e, value) => {
    const { answers, quizNumber } = this.state;
    const newAnswers = [...answers];
    const newAnswerObject = newAnswers[quizNumber];
    newAnswerObject[e.target.id] = value;

    this.setState({
      ...this.state,
      answers: newAnswers
    });
  }

  openQuizModal = () => {
    const { tutorial, quizNumber } = this.state;

    this.setState({ isOpenQuizModal: true, answers: [{[tutorial.spd_quizzes[quizNumber].id]: ''}] });
  }

  closeQuizModal = () => {
    const { tutorial, quizResult } = this.state;

    if(quizResult >= 8 && tutorial.cpd_status) {
      this.initTutorial();
    }
    this.setState({ isOpenQuizModal: false, quizResult: null });
  }

  nextQuestion = event => {
    event.preventDefault();
    const { tutorial, quizNumber, answers } = this.state;
    const newAnswers = [...answers];

    newAnswers.push({ [tutorial.spd_quizzes[quizNumber + 1].id]: '' });

    this.setState(({quizNumber}) => ({quizNumber: quizNumber + 1, answers: newAnswers}));
  }

  submitAnswers = event => {
    event.preventDefault();
    const { tutorial, answers } = this.state;
    const answersObject = {};
    answers.forEach(answer => {
      const key = Object.keys(answer)[0];

      answersObject[key] = answer[key] === 'true';
    });

    new HttpClient().post(ANSWERS, { answers: answersObject, id: tutorial.id })
    .then(response => {
      if(response.body.completed === 'you completed')
        this.setState({quizResult: response.body.quiz_result, quizNumber: 0});
    })
    .catch(e => {
      this.setState({quizResult: e.body.quiz_result, quizNumber: 0});
    });
  }

  render() {
    const { tutorial, isOpenQuizModal, quizNumber, answers, quizResult } = this.state;
    // let classes = classNames('preview-wrapper row justify-content-center', {
    //   'over-one-row' : this.isOverOneRow()
    // });

    // const tutorialQuestions = this.state.tutorial.questions.map((item) => {
    //   return (
    //     <div className="question-preview col-lg-3 col-md-4 col-6"
    //          key={item.id}>
    //       <TutorialQuestion
    //         title={item.title}
    //         question_duration={item.start_time}
    //         question_img={item.thumbnail_url}
    //         isShownQuestion={true}
    //         end_time={item.end_time}
    //       />
    //     </div>
    //   )
    // });

    return (
      <section className="section tutorial">
        <ol className="breadcrumbs">
          <li className="breadcrumb-item"><Link to="/dashboard">Dashboard</Link></li>
          <li className="breadcrumb-item"><Link to="/categories">Tutorials</Link></li>
          <li className="breadcrumb-item active">
            <Link to={`/categories/?slug=${tutorial.category_slug}`}>
              {tutorial.category_title}
            </Link>
          </li>
        </ol>
        <TutorialVideo
          tutorial_title={tutorial.title}
          tutorial_src={VIMEO_PLAYER_PREFIX + tutorial.video_id}
          tutorial_desc={tutorial.description}
          isAdmin={this.props.userStore.isAdmin()}
          id={tutorial.id}
          completed={tutorial.completed}
          cpd_status={tutorial.cpd_status}
          initTutorial={this.initTutorial}
          openQuizModal={this.openQuizModal}
        />
        { tutorial.spd_quizzes &&
          <QuizModal
            isOpenQuizModal={isOpenQuizModal}
            closeQuizModal={this.closeQuizModal}
            quiz={tutorial.spd_quizzes[quizNumber]}
            quizNumber={quizNumber}
            nextQuestion={this.nextQuestion}
            submitAnswers={this.submitAnswers}
            onAnswerEdit={this.onAnswerEdit}
            answer={answers[quizNumber]}
            quizResult={quizResult}
          />
        }
        <div className="tutorial-question" style={{opacity: '0.2'}}></div>
      </section>
    )
  }
}



// WEBPACK FOOTER //
// ./src/modules/tutorial/containers/Tutorial.js